export default __webpack_public_path__ + "static/media/collection-plus.5cc58a39.svg";